/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Button, Table } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { toast } from "react-hot-toast";
import Select from "react-select";
import * as XLSX from "xlsx";
import CsvPreview from "../../../../components/modals/CsvPreview";
import { ExcelFileDownload } from "../../../../utils/helpers/excelFileGenerator";
import {
  agent_branch,
  agent_branch_json,
  cashier_teller,
  cashier_teller_json,
  cust_ind,
  cust_ind_json,
  fileTypes,
} from "../../../../utils/helpers/objectHelpers";
import { EmployeeService } from "../../../../utils/services/employees.service";

function Body({ domainBrand, country, partnerAgent = [] }) {
  const ExcelFile = new ExcelFileDownload();
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const menuPortalTarget = document.getElementById("root");
  const [show, setShow] = useState(false);
  const [dto, setDto] = useState({ keys: [], dto: [] });
  const [fileType, setFileType] = useState("");
  const [mode, setMode] = useState("");
  const [fileName, setFileName] = useState("");
  const [filesJson, setFilesJson] = useState({});
  const [disable, setDisable] = useState(true);
  const [previewCol, setPreviewCol] = useState(false);
  const [agentOption, setAgentOption] = useState("");

  const onChange = async (e) => {
    const file = e.target.files[0];
    const type = e.target.files[0]?.type;
    if (type.includes("spreadsheetml") && file !== undefined) {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const bulkData = XLSX.utils.sheet_to_json(worksheet);
      setFilesJson((prevState) => ({ ...prevState, bulkData }));
      if (fileType.label !== undefined) {
        setDisable(false);
      }
    }
  };

  const filterCountryByName = (word) => {
    const result = country?.filter((i) => i?.common_name === word);
    if (result?.length > 0) {
      return result[0]["iso3Code"];
    } else {
      return "GBR";
    }
  };

  const handleModalPreview = (option) => {
    if (option.label === "Agent/Branch/Partner") {
      const jsonData = agent_branch_json.map((i) => {
        let payload = new Map();
        payload.set("Agent", i.agent);
        payload.set("Agent Code", i.agent_code);
        payload.set("Email", i.email);
        payload.set("Phone", i.phone);
        payload.set("Address", i.address);
        payload.set("City", i.city);
        payload.set("Country", i.country);
        payload.set("PostCode", i.postcode);
        payload.set("Compliance", i.compliance);
        payload.set("Create Sub-Agent", i.create_sub_aget);
        payload.set("BureauDe Change", i.bureaude_change);
        payload.set("PCN-Suffix", i.pcn_suffix);
        payload.set("Length", i.length);
        payload.set("Deposit Point", i.deposit_point);
        payload.set("Collection Point", i.collection_point);
        payload.set("Till_Acct_no", i.till_act_num);
        const csvObject = Object.fromEntries(payload);
        return csvObject;
      });
      setDto({ ...dto, keys: [...agent_branch], dto: jsonData });
      setMode(option.label);
      setFileName("Agent_account_setup.xlsx");
    } else if (option.label === "Cashier/Teller") {
      const jsonData = cashier_teller_json.map((i) => {
        let payload = new Map();
        payload.set("First Name", i.firstName);
        payload.set("Last Name", i.lastName);
        payload.set("Email", i.email);
        payload.set("Phone", i.phone);
        payload.set("Till_Acct_no", i.till_acct_no);
        payload.set("Staff ID", i.staffId);
        payload.set("Pay-In", i.payIn);
        payload.set("Pay-Out", i.payOut);
        const csvObject = Object.fromEntries(payload);
        return csvObject;
      });
      setDto({ ...dto, keys: [...cashier_teller], dto: jsonData });
      setMode(option.label);
      setFileName("Cashier_import_csv.xlsx");
    } else if (option.label === "Branch/Agent Administrator") {
      const jsonData = cust_ind_json.map((i) => {
        let payload = new Map();
        payload.set("First Name", i.firstName);
        payload.set("Last Name", i.lastName);
        payload.set("Email", i.email);
        payload.set("Phone", i.mobile);
        payload.set("Password", i.password);
        payload.set("Staff ID", i.staffId);
        payload.set("Branch Code", i.branch_code);
        const csvObject = Object.fromEntries(payload);
        return csvObject;
      });
      setDto({ ...dto, keys: [...cust_ind], dto: jsonData });
      setMode(option.label);
      setFileName("Agent_administrator_setup.xlsx");
    } else {
      setDto([]);
      setShow(false);
      setMode("");
    }
  };

  const handleBulkUpload = async (type, payload) => {
    if (type === "Agent/Branch/Partner") {
      const objArr = payload?.bulkData;
      const jsonPayload = objArr?.map((i) => {
        const phone = `0${i["Phone"]}`;
        let payload = new Map();
        payload.set("agentName", i["Agent"]);
        payload.set("country", filterCountryByName(i["Country"]));
        payload.set("agentCode", i["Agent Code"]);
        payload.set("email", i["Email"]);
        payload.set("postCode", i["PostCode"]);
        payload.set("subAgentApproval", i["Create Sub-Agent"]);
        payload.set("city", i["City"]);
        payload.set("serialNumberPrefix", i["PCN-Suffix"]);
        payload.set("serialNumberLength", i["length"]);
        payload.set("bureauDeChangeEnabled", i["BureauDe Change"]);
        payload.set("phoneNumber", phone);
        const csvObject = Object.fromEntries(payload);
        return { ...csvObject };
      });
      await addBulkPartnerAgent(jsonPayload);
    } else if (type === "Cashier/Teller") {
      const objArr = payload?.bulkData;
      const jsonPayload = objArr?.map((i) => {
        const phone = `0${i["Phone"]}`;
        let payload = new Map();
        payload.set("firstName", i["First Name"]);
        payload.set("lastName", i["Last Name"]);
        payload.set("email", i["Email"]);
        payload.set("phone", phone);
        payload.set("staffActiveDirectoryId", i["Staff ID"]);
        payload.set("ableToPayIn", i["Pay-In"]);
        payload.set("ableToPayOut", i["Pay-Out"]);
        const csvObject = Object.fromEntries(payload);
        return { ...csvObject, userTypes: "CASHIER", userRoles: ["CASHIER"] };
      });
      await addBulkEmployee(jsonPayload);
    } else if (type === "Branch/Agent Administrator") {
      const objArr = payload?.bulkData;
      const jsonPayload = objArr?.map((i) => {
        const phone = `0${i["Phone"]}`;
        let payload = new Map();
        payload.set("firstName", i["First Name"]);
        payload.set("lastName", i["Last Name"]);
        payload.set("email", i["Email"]);
        payload.set("phone", phone);
        // payload.set("password", i["Password"]);
        payload.set("staffActiveDirectoryId", i["Staff ID"]);
        const csvObject = Object.fromEntries(payload);
        return { ...csvObject, userTypes: "AGENTS", userRoles: ["AGENTS"] };
      });
      await addBulkEmployee(jsonPayload);
    }
  };

  const addBulkEmployee = async (payload) => {
    try {
      const response = await EmployeeService.addEmployee(payload);
      if (response.data.status === "SUCCESS") {
        toast.success(response?.data?.message);
        setFileType("");
        setDisable(true);
        setFileName("");
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      return error;
    }
  };

  const addBulkPartnerAgent = async (payload) => {
    try {
      const response = await EmployeeService.addInternalPaycenter(payload);
      if (response.data.status === "SUCCESS") {
        toast.success(response?.data?.message);
        setFileType("");
        setDisable(true);
        setFileName("");
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      return error;
    }
  };

  const handleDefaultDownload = (dto, fileName) => {
    ExcelFile.generateDefaultCsv(dto, fileName);
  };

  return (
    <React.Fragment>
      <div className="app-content hor-content">
        <div className="container">
          <div className="page-header">
            <div>
              <h1 className="page-title">
                {dictionary
                  ? dictionary["m_load_data_from_file"]
                  : "Import Data From File"}
              </h1>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">
                  {dictionary
                    ? dictionary["para_load_data_from_file_desc"]
                    : "Upload a .csv file with the information to load to the database with the correct format."}
                </li>
              </ol>
            </div>
            <div className="ms-auto pageheader-btn" />
          </div>

          <div className="row row-sm">
            <div className="col-lg-12">
              <div className="card overflow-hidden">
                <div className="card-header bg-primary text-white">
                  <h3 className="card-title fw-bold">Upload Files</h3>
                </div>
                <div className="card-body">
                  <form
                    onSubmit={(e) => e.preventDefault()}
                    className="needs-validation"
                  >
                    <div className="form-row">
                      <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                        <label>
                          {dictionary
                            ? dictionary["SELECT_IMPORT_TYP_861904470"]
                            : "Select the type of user account you wish to create"}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          options={fileTypes()}
                          isClearable={false}
                          isSearchable={true}
                          maxMenuHeight={250}
                          menuPlacement="bottom"
                          menuPortalTarget={menuPortalTarget}
                          value={fileType}
                          name="pycenter-partner"
                          onChange={(option) => {
                            setFileType(option);
                            // setShow(true);
                            handleModalPreview(option);
                            setPreviewCol(true);
                          }}
                        />
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                        <label>
                          {dictionary
                            ? dictionary["l_file_upload"]
                            : "File Upload"}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Form.Control
                          type="file"
                          onChange={onChange}
                          className="form-control"
                        />
                      </div>

                      {previewCol && (
                        <div className="col-lg-6 col-md-6">
                          {fileType.label === "Agent/Branch/Partner" && (
                            <label>
                              {dictionary
                                ? dictionary["WO_SUPER_AGEN_1661028819"]
                                : "Super Agent"}
                            </label>
                          )}

                          {fileType.label === "Cashier/Teller" && (
                            <label>
                              {dictionary
                                ? dictionary["para_pay_center"]
                                : "Agent/Branch"}
                            </label>
                          )}

                          {fileType.label === "Branch/Agent Administrator" && (
                            <label>
                              {dictionary
                                ? dictionary["para_pay_center"]
                                : "Agent/Branch"}
                            </label>
                          )}

                          <Select
                            options={partnerAgent}
                            getOptionLabel={(option) => option?.name}
                            getOptionValue={(option) => option?.id}
                            isClearable={false}
                            isSearchable={true}
                            maxMenuHeight={250}
                            menuPlacement="bottom"
                            menuPortalTarget={menuPortalTarget}
                            value={agentOption}
                            name="pycenter-partner"
                            onChange={(option) => {
                              setAgentOption(option);
                            }}
                          />
                        </div>
                      )}

                      {previewCol && (
                        <div className="col-lg-12 col-md-12">
                          <label className="pt-5 mt-3">
                            {dictionary
                              ? dictionary["FILE_WITH_DATA_YOU_W_1317679651"]
                              : `File with data you wish to upload has to be in ".csv" format and the columns inside need to follow this order`}
                          </label>
                          <Table striped responsive>
                            <thead>
                              <tr>
                                {dto?.keys?.length > 0 && (
                                  <React.Fragment>
                                    {dto?.keys?.map((i, index) => {
                                      return (
                                        <React.Fragment>
                                          <th
                                            key={index}
                                            className=""
                                            style={{ fontSize: "12px" }}
                                          >
                                            {i}
                                          </th>
                                        </React.Fragment>
                                      );
                                    })}
                                  </React.Fragment>
                                )}
                              </tr>
                            </thead>
                          </Table>

                          <Button
                            variant="primary"
                            onClick={() => handleDefaultDownload(dto, fileName)}
                            disabled={mode === "" ? true : false}
                            className="w-100 pt-3 mt-3 fw-bold"
                          >
                            {dictionary
                              ? dictionary["DOWNLOAD_CSV_SAMPL_-235068646"]
                              : "Download CSV Sample"}
                          </Button>
                        </div>
                      )}
                    </div>
                    <div className="d-flex flex-row justify-content-end w-50 float-end">
                      <button
                        className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center fw-bold"
                        type="button"
                        disabled={disable}
                        onClick={() => {
                          handleBulkUpload(fileType.label, filesJson);
                        }}
                      >
                        {dictionary
                          ? dictionary["WO_UPLOAD_FIL_535977066"]
                          : "Upload File"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Body;

/**
 * <CsvPreview
        show={show}
        handleClose={() => setShow(false)}
        domainBrand={domainBrand}
        dto={{ ...dto }}
        mode={mode}
        fileName={fileName}
      />
 */
